var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== 'function' && b !== null) throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import React from 'react';
var DatamapState = /** @class */function (_super) {
  __extends(DatamapState, _super);
  function DatamapState(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      isActive: false
    };
    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    return _this;
  }
  DatamapState.prototype.componentDidMount = function () {
    window.addEventListener('scroll', this.handleMouseLeave);
  };
  DatamapState.prototype.componentWillUnmount = function () {
    window.removeEventListener('scroll', this.handleMouseLeave);
  };
  DatamapState.prototype.handleMouseEnter = function () {
    var _a = this.props,
      name = _a.name,
      value = _a.value,
      index = _a.index;
    this.setState({
      isActive: true
    });
    this.props.mouseEnterOnState(name, value, index);
  };
  DatamapState.prototype.handleMouseLeave = function () {
    this.setState({
      isActive: false
    });
  };
  DatamapState.prototype.render = function () {
    var stateStyle = {
      fill: this.state.isActive ? this.props.hoverColor || '#FFCCBC' : this.props.fillColor,
      stroke: this.state.isActive ? this.props.hoverBorderColor || '#FF5722' : this.props.borderColor,
      strokeWidth: 0.5
    };
    return React.createElement('path', {
      className: 'datamap-state',
      // @ts-ignore
      style: stateStyle,
      d: this.props.path(),
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave
    });
  };
  return DatamapState;
}(React.Component);
export default DatamapState;